import { useState } from 'react'

export default function TemplateForm({ template, onSubmit, onCancel, loading }) {
  const [formData, setFormData] = useState({
    Name: template?.Name || '',
    Language: template?.Language || 'en',
  })
  const [errors, setErrors] = useState({})

  const validate = () => {
    const newErrors = {}
    if (!formData.Name.trim()) newErrors.Name = 'Name is required'
    if (!formData.Language.trim()) newErrors.Language = 'Language is required'
    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!validate()) return

    const submitData = {
      Name: formData.Name.trim(),
      Language: formData.Language.trim(),
    }

    const result = await onSubmit(submitData)
    if (result?.error) {
      setErrors({ submit: result.error.message })
    }
  }

  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }))
    if (errors[field]) {
      setErrors(prev => ({ ...prev, [field]: undefined }))
    }
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Template Name *
        </label>
        <input
          type="text"
          value={formData.Name}
          onChange={(e) => handleChange('Name', e.target.value)}
          className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-primary-500 focus:border-transparent"
          placeholder="e.g., otp_verification"
        />
        {errors.Name && <p className="mt-1 text-sm text-red-600 dark:text-red-400">{errors.Name}</p>}
        <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
          Must match the template name registered in Meta Business Manager
        </p>
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Language *
        </label>
        <select
          value={formData.Language}
          onChange={(e) => handleChange('Language', e.target.value)}
          className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-primary-500 focus:border-transparent"
        >
          <option value="en">English (en)</option>
          <option value="en_US">English US (en_US)</option>
          <option value="en_GB">English UK (en_GB)</option>
          <option value="es">Spanish (es)</option>
          <option value="pt_BR">Portuguese BR (pt_BR)</option>
          <option value="fr">French (fr)</option>
          <option value="de">German (de)</option>
          <option value="af">Afrikaans (af)</option>
          <option value="zu">Zulu (zu)</option>
        </select>
        {errors.Language && <p className="mt-1 text-sm text-red-600 dark:text-red-400">{errors.Language}</p>}
      </div>

      {errors.submit && (
        <div className="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg p-4">
          <p className="text-sm text-red-800 dark:text-red-200">{errors.submit}</p>
        </div>
      )}

      <div className="flex justify-end space-x-3 pt-4">
        <button
          type="button"
          onClick={onCancel}
          disabled={loading}
          className="px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-600 transition disabled:opacity-50"
        >
          Cancel
        </button>
        <button
          type="submit"
          disabled={loading}
          className="px-4 py-2 text-sm font-medium text-white bg-primary-500 rounded-lg hover:bg-primary-600 transition disabled:opacity-50 flex items-center space-x-2"
        >
          {loading && (
            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
          )}
          <span>{template ? 'Update' : 'Create'} Template</span>
        </button>
      </div>
    </form>
  )
}
